/*
    Description: main menu (hamburger) class
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/

class Menu{

    // constructor
    constructor({
        // add selectors
        menuIcon = ".menu-burger",
        mobileMenuIcon = "--js-mobile-icon",        
        menuOverlayClass = "--js-mobile-menu",
        noScrollClass = "--js-noscroll",
        menuWrapper = '.menu',
    } = {}){
        
        // body
        this.body = (document.getElementsByTagName("body"))? document.getElementsByTagName("body")[0] : null;

        // get menu icon
        this.menuIcon = document.querySelector(menuIcon);
        
        // mobile menu icon
        this.mobileMenuIcon = mobileMenuIcon;

        // get menu wrapper
        this.menu = document.querySelector(menuWrapper);

        // menu overlay class
        this.overlayMenu = menuOverlayClass;

        // no scroll
        this.noScroll = noScrollClass;

        // run init method
        this.init()

    }

    // init method
    init(){

        // add listeners
        if(this.menuIcon) this.menuIcon.addEventListener("click", this.menuToggle.bind(this))

    }

    // menu toggle (expand/collapse) event (click)
    menuToggle(e){

        // prevent default
        e.preventDefault();
        
        // make sure we have menu selector
        if(!this.menu || !this.body || !this.menuIcon) return;
        
        // get all classes
        const menuIconClasses = this.menuIcon.classList,
        
        // get menu class
        menuClasses = this.menu.classList,

        // get body classes
        bodyClasses = this.body.classList;

        // body
        (bodyClasses.contains(this.noScroll)) ? bodyClasses.remove(this.noScroll) : bodyClasses.add(this.noScroll);

        // menu icon
        (menuIconClasses.contains(this.mobileMenuIcon)) ? menuIconClasses.remove(this.mobileMenuIcon) : menuIconClasses.add(this.mobileMenuIcon);

        // menu
        (menuClasses.contains(this.overlayMenu)) ? menuClasses.remove(this.overlayMenu) : menuClasses.add(this.overlayMenu);

        // return toggle class
        return;

    }

}

// export default
export default Menu;